import React from "react";
import { ICalendarTaskItem } from "ui/Scripts/source/models/calendarTask/calendarTaskItem";
import { ICalendarTaskPermissions } from "ui/Scripts/source/models/calendarTask/calendarTaskPermissions";
import { Translations } from "ui/Scripts/source/models/translations";

interface ICalendarTaskViewMenuProps {
  item: ICalendarTaskItem;
  permissions: ICalendarTaskPermissions;
  onEdit: (id: string) => void;
  onRemove: (id: string) => void;
  onCancel: () => void;
}

export const CalendarTaskViewMenu = (props: ICalendarTaskViewMenuProps) => {
    const handleEditClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onEdit(props.item?.id);
    };

    const handleEditSeriesClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onEdit(props.item?.parentId);
    };

    const handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onRemove(props.item?.id);
    };

    const handleRemoveSeriesClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onRemove(props.item?.parentId);
    };

    const handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onCancel();
    };

    return (
        <div className="listPopupMenu" onClick={handleCancelClick}>
            <div className="menu">
                <div className="line" onClick={handleEditClick}>
                    {props.item.parentId
                        ? (props.permissions.canSaveCalendarTask ? Translations.CalendarTaskEditOccurrence : Translations.CalendarTaskOpenOccurrence)
                        : (props.permissions.canSaveCalendarTask ? Translations.Edit : Translations.Open)}
                </div>
                {props.item.parentId && (
                    <div className="line" onClick={handleEditSeriesClick}>
                        {props.permissions.canSaveCalendarTask ? Translations.CalendarTaskEditSeries : Translations.CalendarTaskOpenSeries}
                    </div>
                )}
                {props.permissions.canRemoveCalendarTask &&
                    <div className={"line"} onClick={handleRemoveClick}>
                        {props.item.parentId
                            ? Translations.CalendarTaskRemoveOccurrence
                            : Translations.Remove}
                    </div>
                }
                {props.item.parentId && props.permissions.canRemoveCalendarTask && (
                    <div className="line" onClick={handleRemoveSeriesClick}>
                        {Translations.CalendarTaskRemoveSeries}
                    </div>
                )}
                <div className="line" onClick={handleCancelClick}>
                    {Translations.Cancel}
                </div>
            </div>
        </div>
    );
};
